import React from 'react';
import { BaseInputProps, Dropdown } from 'ui-builder';

export interface CountryDropdownProps extends BaseInputProps {

}

export function CountryDropdown(props: CountryDropdownProps) {
  return (
    <Dropdown
      options={[
        {
          label: 'United States',
          value: 'US'
        },
        {
          label: 'Canada',
          value: 'CA'
        }
      ]}
      {...props}
    />
  );
}
